import { handleAction } from '@mendeley-internal/lib-js-redux-actions';
import { getUrlResolvers } from '../actions/url-resolvers';

const isTimeout = ({ code }) => code === 'ECONNABORTED';

export default handleAction(getUrlResolvers, {
  first() {
    return { fetching: true };
  },
  next(state, { payload }) {
    return payload;
  },
  throw(state, { payload }) {
    return { error: true, timeout: isTimeout(payload) };
  }
}, null);



// WEBPACK FOOTER //
// ./src/universal/ui/reducers/url-resolvers.js